const decimalPattern = /(-?\d+)\.0+\b/g;

export const formatNotificationCopy = (value: string | null | undefined): string => {
  if (!value) return "";
  return value.replace(decimalPattern, (_match, integerPart) => integerPart);
};
